import React, {Component} from 'react'
// import { Row, Col, FormControl, Modal, Form, FormGroup, Button } from 'react-bootstrap'
import { Checkbox } from 'react-icheck'
import PrintPreview from '../PrintPreview'
// import FontAwsome from 'react-fontawesome'
import PdfStore from '../../../stores/PdfStore'
import TextFieldModal from '../../../component/element/TextFieldModal'
import WorkdocStore from '../../../stores/WorkdocStore'

const Barcode = require('react-barcode');
var NotificationSystem = require('react-notification-system');
const DEFAULT_ROW = 13
class PrintBHLFixingListOnCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {fontSize:'lg',isAllText:false,isCheckAll:false,related_detail:{},dataList:[],loading:false,page_title:'กำลังดึงข้อมูล..',data:{work_no:'',car:{car_registration_no:''},insurer:{claim_no:''},
    receiving:{entrance_date:'',appointment_date:''},
    wagelist:[],partlist:[]},wageList:[],partList:[]}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadFixingListOnCarDoc()
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {detail:''}
    })
  }

  newEmptyPage(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {wagelist:{wagelist:[]},partlist:{partlist:[]},remark:false}
    })
  }

  newEmptyRelated(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {value:false}
    })
  } 

  loadFixingListOnCarDoc() {
    let {workNo} = this.props
    let {related_detail,dataList,isAllText} = this.state
    this.setState({ loading: true })
    PdfStore.loadFixingListOnCarDoc(workNo,'bhl_fixoncar_doc',(result) => {

      if (result.data.related_detail===undefined) {
        related_detail = {status:this.newEmptyRelated(this.getPagination(result.data).length),status1:this.newEmptyRelated(this.getPagination(result.data).length),remark:this.newEmptyRelated(this.getPagination(result.data).length),text:this.newEmptyRelated(this.getPagination(result.data).length)} 
      } else {
        related_detail = result.data.related_detail
      }

      if (related_detail.status===undefined)
        related_detail.status = Object.assign(this.newEmptyRelated(this.getPagination(result.data).length), related_detail.status)

      if (related_detail.status1===undefined)
        related_detail.status1 = Object.assign(this.newEmptyRelated(this.getPagination(result.data).length), related_detail.status1)

      if (related_detail.remark===undefined)
        related_detail.remark = Object.assign(this.newEmptyRelated(this.getPagination(result.data).length), related_detail.remark)

      if (related_detail.text===undefined)
        related_detail.text = Object.assign(this.newEmptyRelated(this.getPagination(result.data).length), related_detail.text)

      let data = result.data
      dataList = this.getPagination(data)
      if (dataList.length>1)
        isAllText = true

      this.setState({data:data,dataList:dataList,related_detail:related_detail,isAllText:isAllText})
    })  
  }

  onRadioChange(val,index,key,e) {
    let {related_detail} = this.state

    if (val) {
      if (key===0)
        related_detail.status[0].value = false
      else if (key===1)
        related_detail.status1[0].value = false
    } else {
      if (key===0)
        related_detail.status[0].value = true
      else if (key===1)
        related_detail.status1[0].value = true
    }
    this.setState({related_detail:related_detail})
    this.saveWorkdocRelated()
  }

  saveWorkdocRelated() {
    let {workNo} = this.props
    let {related_detail} = this.state

    WorkdocStore.saveWorkdocRelated(workNo,'bhl_fixoncar_doc',related_detail,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })    
  }

  onNoteClick(index,title,e) {
    let {related_detail} = this.state
    let fieldInfo = {title:title,showClear:false,value:(!related_detail.remark[0].value?'':related_detail.remark[0].value),key:index}
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  onTextClick(index,title,e) {
    let {related_detail} = this.state
    let fieldInfo = {title:title,showClear:false,value:(!related_detail.text[0].value?'':related_detail.text[0].value),key:index}
    this.refs.textFieldModal1.loadInfo(fieldInfo)
  }

  onNoteSave(fieldInfo) {
    let {related_detail} = this.state
    related_detail.remark[0].value = fieldInfo.value
    this.setState({related_detail:related_detail})
    this.saveWorkdocRelated()
  }

  onTextSave(fieldInfo) {
    let {related_detail,isCheckAll} = this.state
    
    if (isCheckAll) {
      related_detail.text.forEach(function(item,index) {
        related_detail.text[0].value = fieldInfo.value
      })
    } else { 
      related_detail.text[0].value = fieldInfo.value
    }
    
    this.setState({related_detail:related_detail,isCheckAll:false})
    this.saveWorkdocRelated()
  }

  onCheckAll(value) {
    let {isCheckAll} = this.state
    this.setState({isCheckAll:value})
  }

  onCarChange(key) {
    let {data} = this.state
    let {workNo} = this.props

    if (key===data.car.accident_type) {
      data.car.accident_type = ''
      key = ''
    } else {
      data.car.accident_type = key
    }  

    data.car.accident_type = key
    this.setState({data:data})
    let postData = {wo:workNo,accident_type:key}

    WorkdocStore.saveInfoAccidentType(postData,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  renderHeader() {
  	let {data,fontSize} = this.state
  	return(
  		<div style={{width:'100%'}}>
        	<div style={{width:'50%',display:'inline-block',padding:'5px'}}>
        		<table className={'table table-print-bhl-fixing-list-on-car-check font-'+fontSize} style={{marginBottom:'0'}}>
        			<tbody>
        				<tr>
        					<td>{data.insurer===undefined?'บริษัท':''} {data.insurer===undefined?'':data.insurer.insurer_name}</td>
        				</tr>
        				<tr>
        					<td>ยี่ห้อ {data.car===undefined?'':data.car.brand}</td>
        				</tr>
        				<tr>
        					<td>วันรถเข้าซ่อม {data.receiving===undefined?'':data.receiving.contact_date}</td>
        				</tr>
        			</tbody>
        		</table>
        	</div>
        	<div style={{width:'50%',display:'inline-block',padding:'5px'}}>
        		<table className={'table table-print-bhl-fixing-list-on-car-check font-'+fontSize} style={{marginBottom:'0'}}>
        			<tbody>
        				<tr>
        					<td className='text-center'>
        						<Checkbox
        							onChange={this.onCarChange.bind(this,'รถประกัน')}
					            checked={data.car.accident_type==='รถประกัน'?true:false}
					            checkboxClass="icheckbox_minimal"
					            increaseArea="20%"
					            label={' รถประกัน'}
					            >
					            </Checkbox>
        					</td>
        					<td className='text-center'>
        						<Checkbox
        							onChange={this.onCarChange.bind(this,'รถคู่กรณี')}
					            checked={data.car.accident_type==='รถคู่กรณี'?true:false}
					            checkboxClass="icheckbox_minimal"
					            increaseArea="20%"
					            label={' รถคู่กรณี'}
					            >
					            </Checkbox>
        					</td>
        				</tr>
        				<tr>
        					<td colSpan={2}>ทะเบียนรถ {data.car===undefined?'':data.car.car_registration_no}</td>
        				</tr>
        				<tr>
        					<td colSpan={2}>วันนัดรถเสร็จ {data.receiving===undefined?'':data.receiving.appointment_date}</td>
        				</tr>
        			</tbody>
        		</table>
        	</div>
        </div>
  	)
  }

  renderWageRowData(items,indexs) {
  	return(
  		items.wagelist.wagelist.map((item,index) => {
  			return(
  				<tr key={index}>
  					<td className=''>{index+1}. {item.detail}</td>
  				</tr>
  			)
  		})
  	)
  }

  renderPartRowData(items,indexs) {
  	return(
  		items.partlist.partlist.map((item,index) => {
  			return(
  				<tr key={index}>
  					<td className=''>{index+1}. {item.detail}</td>
  				</tr>
  			)
  		})
  	)
  }

  renderBody(items,indexs) {
    let {fontSize} = this.state
  	return(
  		<div style={{width:'100%'}}>
        	<div style={{width:'50%',float:'left',padding:'5px'}}>
        		<table className={'table table-print-bhl-fixing-list-on-car-doc font-'+fontSize} style={{marginBottom:'0'}}>
        			<tbody>
        				<tr>
        					<td className='text-center br-t'>รายการเคาะพ่น *สี*</td>
        				</tr>
        				{this.renderWageRowData(items,indexs)}
        			</tbody>
        		</table>
        	</div>
        	<div style={{width:'50%',float:'right',padding:'5px'}}>
        		<table className={'table table-print-bhl-fixing-list-on-car-doc font-'+fontSize} style={{marginBottom:'0'}}>
        			<tbody>
        				<tr>
        					<td className='text-center br-t'>รายการอะไหล่ที่ *เปลี่ยน*</td>
        				</tr>
        				{this.renderPartRowData(items,indexs)}
        			</tbody>
        		</table>
        	</div>
        </div>
  	)
  }

  renderFooter(index) {
    let {related_detail,fontSize} = this.state
  	return(
  		<div className='footer-page'>
  			<table className={'table table-print-bhl-fixing-list-on-car-check font-'+fontSize} style={{marginBottom:'0'}}>
        		<tbody>
        			<tr>
        				<td style={{fontWeight:'bold',fontSize:'30px',width:'50px'}} onClick={this.onNoteClick.bind(this,index,'หมายเหตุ')}>
        					หมายเหตุ
        				</td>
        				<td className='' onClick={this.onNoteClick.bind(this,index,'หมายเหตุ')} style={{borderBottom:'2px dotted'}}>
        					{related_detail.remark===undefined||!related_detail.remark[0].value||related_detail.remark[0].value===''?'':related_detail.remark[0].value}
        				</td>
        			</tr>
        		</tbody>
        	</table>
  		</div>
  	)
  }

  renderComponentPage(item,index) {
  	let {related_detail,fontSize} = this.state

    return(
      <div className={'font-print'} key={index}> {/* font-22 */}
        <h2 className='text-center' style={{fontWeight:'bold'}}>{this.props.title}</h2>
        <div style={{width:'100%'}}>
        	<div style={{width:'50%',display:'inline-block',padding:'5px'}}>
        		<table className={'table table-print-bhl-fixing-list-on-car-doc font-'+fontSize} style={{marginBottom:'0'}}>
        			<tbody>
        				<tr>
        					<td className='text-center br-t'>
        						<Checkbox
					                onChange={this.onRadioChange.bind(this,related_detail.status[0].value,index,0)}
					                checked={related_detail.status[0].value?true:false}
					                checkboxClass="icheckbox_minimal"
					                increaseArea="20%"
					                label={' ใช้ทะเบียนถ่ายรูป'}
					              >
					            </Checkbox>
        					</td>
        				</tr>
        				<tr>
        					<td className='text-center'>
        						<Checkbox
					                onChange={this.onRadioChange.bind(this,related_detail.status1[0].value,index,1)}
					                checked={related_detail.status1[0].value?true:false}
					                checkboxClass="icheckbox_minimal"
					                increaseArea="20%"
					                label={' ใช้เลขเคลมถ่ายรูป'}
					              >
					            </Checkbox>
        					</td>
        				</tr>
        			</tbody>
        		</table>
        	</div>
        	<div style={{width:'50%',display:'inline-block',padding:'5px'}}>
        		<table className={'table table-print-bhl-fixing-list-on-car-doc font-'+fontSize} style={{marginBottom:'0',tableLayout:'fixed'}}>
        			<tbody>
        				<tr>
        					<td className='box-bhl-height br-t' style={{display:'block',whiteSpace:'pre-line',overflow:'hidden',textOverflow:'ellipsis'}} onClick={this.onTextClick.bind(this,index,'ข้อความ')}>{related_detail.text[0].value}</td>
        				</tr>
        			</tbody>
        		</table>
        	</div>
        </div>
        {this.renderHeader()}
        {this.renderBody(item,index)}
        <div className={'text-center wrap-barcode font-'+fontSize}>
          <Barcode 
            value={this.props.workNo}
            width={2}
            height={50}
            fontSize={12}
          />
        </div>        
        {this.renderFooter(index)}
      </div>  
    )
  }

  getPagination(data) {
  	let allList = []
  	let wagelist = []
  	let newData = []
  	let checkRow = 0
  	data.wagelist.forEach(function(item,index) {
  		if (checkRow<DEFAULT_ROW) {
  			newData.push(item)
  			checkRow++
  		}
  		if (checkRow===DEFAULT_ROW-1||index===data.wagelist.length-1) {
  			wagelist.push({
  				wagelist: newData
  			})
  			newData = []
  			checkRow = 0
  		}
  	})

  	let partlist = []
  	newData = []
  	checkRow = 0
  	data.partlist.forEach(function(item,index) {
  		if (checkRow<DEFAULT_ROW) {
  			newData.push(item)
  			checkRow++
  		}
  		if (checkRow===DEFAULT_ROW-1||index===data.partlist.length-1) {
  			partlist.push({
  				partlist: newData
  			})
  			newData = []
  			checkRow = 0
  		}
  	})

  	let maxNum = Math.max(wagelist.length, partlist.length)
  	allList = this.newEmptyPage(maxNum)
  	allList.forEach(function(item,index) {
  		if (wagelist[index]!==undefined)
  			allList[index].wagelist = wagelist[index]

  		if (partlist[index]!==undefined)
  			allList[index].partlist = partlist[index]
  	})
  	let that = this
  	allList.forEach(function(item,index) { 
  		if (item.partlist.partlist.length>0)
  			allList[index].partlist.partlist = item.partlist.partlist.concat(that.newEmptyRow(DEFAULT_ROW-item.partlist.partlist.length-1))
  		else
  			allList[index].partlist.partlist = that.newEmptyRow(DEFAULT_ROW-item.partlist.partlist.length-1)

  		if (item.wagelist.wagelist.length>0)
  			allList[index].wagelist.wagelist = item.wagelist.wagelist.concat(that.newEmptyRow(DEFAULT_ROW-item.wagelist.wagelist.length-1))
  		else
  			allList[index].wagelist.wagelist = that.newEmptyRow(DEFAULT_ROW-item.wagelist.wagelist.length-1)
  	})	

  	return allList
  }

  onFontClick(size) {
    this.setState({fontSize:size})
  }

  render() {
    let {loading,dataList,isAllText,fontSize} = this.state
    return(
      <div>
        <PrintPreview 
            loading={loading}
            leftBarTitle={this.props.title+' '+this.props.workNo}
            defaultFont={fontSize}
            onFontClick={this.onFontClick.bind(this)}
        >
            {
            	dataList.map((item,index) => {
            		return(
            			this.renderComponentPage(item,index)
            		)
            	})
            }
        </PrintPreview>
        <TextFieldModal 
          ref='textFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onNoteSave.bind(this)}
        />
        <TextFieldModal 
          ref='textFieldModal1'
          confirmTitle='บันทึก'
          onConfirm={this.onTextSave.bind(this)}
          onCheckAll={this.onCheckAll.bind(this)}
          isAllText={false}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintBHLFixingListOnCarDoc.defaultProps = {
  title: 'ใบจ่ายงาน',  
  mode : '1'
}
export default PrintBHLFixingListOnCarDoc;


// WEBPACK FOOTER //
// ./src/view/print/bhl/PrintBHLFixingListOnCarDoc.js